<template>
  <svg
    viewBox="0 0 24 24"
    aria-hidden="true"
    class="r-4qtqp9 r-yyyyoo r-1xvli5t r-dnmrzs r-bnwqim r-1plcrui r-lrvibr r-1hdv0qi"
  ><g><circle
    cx="5"
    cy="12"
    r="2"
  /><circle
    cx="12"
    cy="12"
    r="2"
  /><circle
    cx="19"
    cy="12"
    r="2"
  /></g></svg>
</template>